
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.7 4.757c0-.495-.405-.9-.9-.9h-9c-.495 0-.9.405-.9.9v2.637l-.891 6.237a.905.905 0 00.207.72.901.901 0 00.684.306h3.528a.897.897 0 00.738-.387l.99-1.43c.045 0 .09.017.144.017.054 0 .099-.009.144-.018l.99 1.431a.897.897 0 00.738.387H11.7a.934.934 0 00.684-.306.874.874 0 00.207-.72L11.7 7.394V4.757zm-9 .9h7.2v.9H2.7v-.9zm3.618 4.527h-.027L5.193 8.357h2.223l-1.098 1.827zM3.96 12.857H1.944l.648-4.527s.072.027.117.027h.387l1.845 3.078-.981 1.422zm4.689 0l-.981-1.422 1.845-3.078H9.9s.072-.018.117-.027l.648 4.527H8.649zM15.3 5.657h1.8c.495 0 .9-.405.9-.9s-.405-.9-.9-.9h-1.8c-.495 0-.9.405-.9.9s.405.9.9.9zM17.1 8.357h-1.8c-.495 0-.9.405-.9.9s.405.9.9.9h1.8c.495 0 .9-.405.9-.9s-.405-.9-.9-.9zM17.1 12.857h-1.8c-.495 0-.9.405-.9.9s.405.9.9.9h1.8c.495 0 .9-.405.9-.9s-.405-.9-.9-.9z"}})])
          )
        }
      }
    